<template>
  <div class="news-detail">
    <div class="container">
      <h1>{{ newsItem.title }}</h1>
      <div class="news-meta">
        <span class="news-date">{{ newsItem.date }}</span>
      </div>
      <div class="news-content">
        <div v-html="newsItem.content"></div>
      </div>
      <div class="back-link">
        <router-link to="/news">← 返回新闻列表</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppNewsDetail',
  data() {
    return {
      newsItem: {
        title: '',
        date: '',
        content: ''
      }
    }
  },
  mounted() {
    // 获取新闻ID并加载对应的新闻内容
    this.loadNewsDetail(this.$route.params.id);
  },
  methods: {
    loadNewsDetail(id) {
      // 这里可以从API或本地数据获取新闻详情
      // 暂时使用模拟数据
      const newsData = {
        '1': {
          title: '权威认证，实力加冕！',
          date: '2025-10-22',
          content: `<p>近日，山东隆之智环保科技有限公司迎来发展历程中的重要里程碑！中华环保联合会秘书长吴克食先生携权威专家黄威、高红一行，共同莅临隆之智，就挥发性有机物（VOCs）泄漏检测与修复（LDAR）服务认证工作进行了全面、细致的现场审查与指导。</p><img src="${require('../assets/1.jpg')}" alt="认证现场合影" class="news-image" /><p>认证过程中，专家组依据高标准、严要求，通过现场审查、问卷调查等方式，对我司的服务管理体系、质量控制流程、人员技术能力及过往项目业绩等方面进行了系统、深入、全面的评估与核查，更深入工程现场，对实际项目操作进行了实地勘察，并给予专业的梳理与指导建议，为我公司LDAR服务的持续优化提升指明了方向，更注入了权威动能。</p><img src="${require('../assets/2.jpg')}" alt="认证现场" class="news-image" /><img src="${require('../assets/3.jpg')}" alt="认证现场" class="news-image" /><p>经过一系列严格评审，隆之智凭借卓越的服务品质、完善的管理体系、专业的技术团队以及丰富的项目经验，顺利通过挥发性有机物泄漏检测与修复服务五星级认证！</p><p>这不仅是对隆之智环保在LDAR领域专业实力和服务水平的高度认可，更是对公司长期以来坚持“技术领先、服务至上”理念的最好褒奖，是一份沉甸甸的荣誉，更是一份沉甸甸的责任。</p><img src="${require('../assets/4.jpg')}" alt="认证证书" class="news-image small-image" /><p>此次荣获五星级认证，标志着公司在LDAR服务领域的规范化、专业化、标准化建设迈上了新台阶，更是新的起点。我们将以此为契机，不忘初心，砥砺前行，持续深化技术创新，优化服务流程，提升服务质量，致力于为更多客户提供更专业、更高效、更可靠的VOCs泄漏检测与修复解决方案，为守护蓝天白云、推动生态文明建设贡献隆之智的智慧与力量！</p>`
        },
        '2': {
          title: '隆之智LDAR平台荣获“淄博市优秀软件产品”！',
          date: '2025-10-20',
          content: `<p>近日，淄博市工业和信息化局发布《2025年淄博市优秀软件企业和软件产名单》，我司自主研发的“泄漏检测与修复（LDAR）管控平台”获评“淄博市优秀软件产品”！</p><img src="${require('../assets/5.png')}" alt="隆之智LDAR管控平台" class="news-image" /><p>隆之智泄漏检测与修复（LDAR）管控平台以“数字化、智能化、可视化”为核心，深度融合物联网、大数据、移动互联网等先进技术，实现了对LDAR工作全生命周期的精细化管理。</p><p>全流程闭环管理：</p><img src="${require('../assets/6.png')}" alt="全流程闭环管理" class="news-image" /><p>从检测任务制定、现场数据采集（支持多种检测设备数据接入）、泄漏点识别与评估、修复任务派发与跟踪，到复测与数据分析，形成完整管理闭环，确保LDAR工作合规高效。</p><p>智能数据分析与预警：</p><img src="${require('../assets/7.png')}" alt="智能数据分析与预警" class="news-image" /><p>通过对海量检测数据的智能分析，实时监控设备密封点状态，精准定位高泄漏风险区域，提供预警机制，助力企业防患于未然。</p><p>移动化便捷作业：</p><img src="${require('../assets/8.png')}" alt="移动化便捷作业" class="news-image" /><p>自主研发的配套终端APP，检测人员可随时随地完成数据录入、拍照上传、任务接收等工作，大幅提升现场作业效率与数据准确性。</p><p>可视化报表与合规报告：</p><img src="${require('../assets/9.png')}" alt="可视化报表与合规报告" class="news-image" /><p>自动生成各类统计报表、趋势分析图及符合监管要求的LDAR报告，为企业决策提供数据支撑，轻松应对环保检查。</p><p>降低成本，提升效益：</p><img src="${require('../assets/10.png')}" alt="降低成本，提升效益" class="news-image" /><p>通过优化检测频次、精准定位泄漏、加快修复响应，有效减少VOCs等物料损耗，降低企业运营成本，提升环境效益与经济效益。</p><img src="${require('../assets/11.png')}" alt="淄博市优秀软件产品" class="news-image" /><p>此次入选不仅是对我司技术实力的认可，更是对未来发展的激励。我们将以此为契机，继续加大研发投入，不断提升产品核心竞争力，致力于为更多企业提供更优质、更智能的LDAR管控解决方案，助力工业企业实现绿色低碳发展，为守护蓝天白云、建设美丽中国贡献科技力量！</p>`
        },
        '3': {
          title: '隆之智LDAR综合管平台服务--培训篇',
          date: '2024-09-04',
          content: `<p>近日，隆之智为合作方山东邦林检测有限公司进行了LDAR检测系统培训，围绕LDAR检测标准要求、检测设备、检测操作规范、LDAR检测系统应用、检测环保安全、检测报告编制等为邦林检测人员进行了系统性培训。</p><img src="${require('../assets/5.jpg')}" alt="LDAR检测系统培训" class="news-image" /><p>隆之智LDAR综合管理系统是企业自主研发的LDAR全流程线上管控系统，系统通过自动化和数字化的管理规范了LDAR工作的流程，提供了数据存储、查询、统计分析、报告等功能，覆盖密封点管理、泄漏检测、泄漏修复、变更管理、审核评估等全生命周期的重要环节，实现对泄漏检测数据的实时监控，帮助企业更好地管理和分析泄漏检测数据，识别泄漏的模式和趋势，优化泄漏修复流程。</p><img src="${require('../assets/6.jpg')}" alt="LDAR综合管理系统" class="news-image" /><p>据悉，隆之智向环保检测行业提供LDAR综合管理系统的共享服务及数据托管服务，并为共享合作方提供系统相关应用的培训服务。</p>`
        },
        '4': {
          title: '隆之智董事长田源当选中华环保联合会理事',
          date: '2024-07-26',
          content: `<p>7月25日，中华环保联合会第四届会员代表大会在京隆重召开。会议选举产生了中华环保联合会第四届理事会，第二届监事会。山东隆之智环保科技有限公司董事长田源当选中华环保联合会第四届理事会理事。</p><img src="${require('../assets/7.jpg')}" alt="中华环保联合会会员代表大会" class="news-image" /><p>作为泄漏检测与修复（LDAR）专业技术服务商，隆之智充分发挥技术研发优势，持续引进行业领先的检测设备，坚持智能软硬件的自主研发，吸纳培养高、精、尖专业人才50余人，拥有专业检测实验室、检测设备100余台套，并创新性地将红外检测技术、声学检测技术、无人监测技术融合到LDAR检测系统，为企业提供专业化、智能化、多维化的专业技术服务，为企业生产安全保驾护航！</p><img src="${require('../assets/8.jpg')}" alt="隆之智技术团队" class="news-image" /><p>田源董事长多年来专注环境监测专业领域研究，在环境气体泄漏监测与修复、泄漏气体追踪技术、智能遥感、远程控制等方面都有着丰富的经验和先进的技术理念。近年来带领团队研究开发了智能动态泄漏监测系统、便携式气体泄漏巡检系统等多项气体泄漏智慧监测解决方案。其中智能动态泄漏监测系统入选“一带一路”生态环境治理技术及产品推荐目录、山东省绿色低碳技术成果目录，并荣获第四届“齐鲁杯”工业设计大赛铜奖。</p>`
        }
      };
      
      this.newsItem = newsData[id] || {
        title: '新闻不存在',
        date: '',
        content: '<p>抱歉，您访问的新闻不存在或已被删除。</p>'
      };
    }
  }
}
</script>

<style scoped>
.news-detail {
  padding: 80px 0;
  background: linear-gradient(135deg, #f9f9f9 0%, #e6f3ee 100%);
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

 h1 {
  font-size: 36px;
  margin-bottom: 20px;
  color: #333;
  text-align: center;
}

.news-meta {
  text-align: center;
  margin-bottom: 40px;
}

.news-date {
  display: inline-block;
  background-color: #42b983;
  color: white;
  padding: 5px 15px;
  border-radius: 4px;
  font-size: 14px;
}

.news-content {
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
  text-align: left;
}

.news-content >>> p {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 20px;
  text-align: left !important;
  text-indent: 2em;
}

.news-content ul {
  margin-bottom: 20px;
  padding-left: 20px;
}

.news-content li {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 10px;
}

.news-content div {
  box-sizing: border-box;
}

.news-content >>> img.news-image {
  width: 100% !important;
  max-width: 600px !important;
  height: auto !important;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;
  display: block;
  object-fit: contain;
  margin: 20px auto;
}

.news-content >>> img.news-image:hover {
  transform: scale(1.02);
}

/* 确保所有动态渲染的图片都遵循相同规则 */
.news-content >>> img {
  width: 100% !important;
  max-width: 800px !important;
  height: auto !important;
  display: block;
  object-fit: contain;
  box-sizing: border-box;
  margin: 20px auto;
}

.news-content >>> img.small-image {
  max-width: 600px !important;
}

.back-link {
  text-align: center;
}

.back-link a {
  color: #42b983;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  transition: color 0.3s ease;
}

.back-link a:hover {
  color: #3aa876;
  text-decoration: underline;
}

@media screen and (max-width: 768px) {
  .news-detail {
    padding: 60px 0;
  }

  h1 {
    font-size: 28px;
  }

  .news-content {
    padding: 30px;
  }
}

@media screen and (max-width: 480px) {
  .news-detail {
    padding: 40px 0;
  }

  h1 {
    font-size: 24px;
  }

  .news-content {
    padding: 20px;
  }

  .news-content p,
  .news-content li {
    font-size: 14px;
  }
}
</style>